import { useState } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect.ts';

type Breakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export function useTailwindBreakpoint(breakpoint: Breakpoint, defaultValue = false) {
  const [match, setMatch] = useState(() => defaultValue);

  useIsomorphicLayoutEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const value = getBreakpointWidth(breakpoint) ?? 999999;
    const query = window.matchMedia(`(min-width: ${value}px)`);

    setMatch(query.matches);

    function listener(event: MediaQueryListEvent) {
      setMatch(event.matches);
    }

    query.addEventListener('change', listener);
    return () => query.removeEventListener('change', listener);
  }, [breakpoint, defaultValue]);

  return match;
}

function getBreakpointWidth(breakpoint: Breakpoint) {
  const styles = window.getComputedStyle(document.documentElement);
  const rootFontSize = styles.fontSize;
  const breakpointRemSize = styles.getPropertyValue(`--breakpoint-${breakpoint}`);
  return parseFloat(breakpointRemSize.split('rem')[0]) * parseFloat(rootFontSize);
}
